import type { ApplyResult, Delta, SkipNote, SkipReason } from "../api/generated";

const REASON_TEXT: Record<SkipReason, string> = {
  ViewChanged: "it was changed since",
  WouldNotApply: "it no longer applies",
  NotInvertible: "it cannot be reversed",
};

export function describeSkipNote(note: SkipNote): string {
  return `${describeDelta(note.delta)} skipped: ${REASON_TEXT[note.reason]}`;
}

function describeDelta(delta: Delta): string {
  if ("Field" in delta) return `${fieldName(delta.Field.after)} change`;
  if ("Member" in delta) return "Tag or dependency change";
  if ("Lifecycle" in delta) return lifecycleName(delta.Lifecycle.kind);
  if ("SeriesAttached" in delta || "SeriesDetached" in delta) return "Recurrence change";
  if ("SeriesField" in delta) return "Recurrence setting change";
  if ("SeriesSpawned" in delta || "SeriesUnspawned" in delta) return "Next recurring instance";
  if ("Setting" in delta) return "Setting change";
  return "Saved filter change";
}

function fieldName(field: Extract<Delta, { Field: unknown }>["Field"]["after"]): string {
  const [name] = Object.keys(field);
  switch (name) {
    case "Title":
      return "Title";
    case "Notes":
      return "Notes";
    case "Priority":
      return "Priority";
    case "Wait":
    case "SchedWait":
      return "Wait date";
    case "Due":
    case "SchedDue":
      return "Due date";
    case "Project":
      return "Project";
    default:
      return "Field";
  }
}

function lifecycleName(kind: Extract<Delta, { Lifecycle: unknown }>["Lifecycle"]["kind"]): string {
  if ("Created" in kind) return "Creation";
  if ("Completed" in kind) return "Completion";
  if ("Uncompleted" in kind) return "Reopening";
  if ("Deleted" in kind) return "Deletion";
  return "Restoration";
}

export function skippedMessages(result: ApplyResult): string[] {
  return result.skipped.map(describeSkipNote);
}
